import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface ConfirmDialogData {
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    warning?: string;
}

@Component({
    selector: 'app-dialog-confirm',
    templateUrl: 'dialog-confirm.html',
    styleUrls: ['dialog-confirm.scss']
})
export class DialogConfirmComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
                private dialogRef: MatDialogRef<DialogConfirmComponent>) {}

    onCancel(): void {
        this.dialogRef.close(false);
    }

    onConfirm(): void {
        this.dialogRef.close(true);
    }
}
